/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const c={create:()=>[0,0,0,0,0,0,0,0,0],copy(c,e){c[0]=e[0],c[1]=e[1],c[2]=e[2],c[3]=e[3],c[4]=e[4],c[5]=e[5],c[6]=e[6],c[7]=e[7],c[8]=e[8]}};export{c as Vector9};
